import { useEffect } from "react";
import "../App.css";

const Reviews = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.async = true;
    script.setAttribute("data-elfsight-app-lazy", "true");
    document.body.appendChild(script);
  }, []);

  return (
    <div className="flex flex-col flex-1 page-fade-in">
      <div className="absolute inset-0 pointer-events-none"
        style={{
          background: "radial-gradient(ellipse 60% 40% at 50% 0%, rgba(200,150,31,0.04) 0%, transparent 70%)",
        }}
      />

      <div className="relative max-w-4xl mx-auto w-full px-6 py-12">
        <div className="flex items-center gap-4 mb-8">
          <span className="section-label">Reviews</span>
          <div className="gold-divider flex-1" />
        </div>

        <div
          className="glass-card rounded-2xl p-4 md:p-6"
          style={{ borderColor: "rgba(255,255,255,0.07)" }}
        >
          <div
            className="elfsight-app-d7234a8a-fc9a-4f57-a3ec-f25fb55b72a8"
            data-elfsight-app-lazy
          />
        </div>
      </div>
    </div>
  );
};

export default Reviews;
